/*
  eslint
  no-param-reassign: ["error", { "props": false }]
*/
import { isValidToken } from '../auth/utils';

export default {
  namespaced: true,
  state: {
    version: '5.x.x',
    mapkit: null,
    jwt: null,
  },
  mutations: {
    SET_MAPKIT(state, mapkit) {
      state.mapkit = mapkit;
    },
    SET_JWT(state, jwt) {
      state.jwt = jwt;
    },
  },
  actions: {
    async getOrRefreshMapKitKey({ dispatch, state, commit }) {
      if (state.jwt !== null && isValidToken(state.jwt)) {
        return state.jwt;
      }
      const jwt = await dispatch('primary/getMapKitKey', {}, { root: true });
      // dispatch('getMapKitKey', {}, { root: true }).then(jwt => done(jwt.jwt));
      if (jwt) {
        commit('SET_JWT', jwt.jwt);
        return jwt.jwt;
      }
      return null;
    },
    async loadMapKit({ dispatch, state, commit }) {
      if (state.map) {
        return;
      }
      const mapkit = await new Promise((resolve, reject) => {
        const src = `https://cdn.apple-mapkit.com/mk/${state.version}/mapkit.js`;
        const script = document.createElement('script');
        script.onload = () => resolve(window.mapkit);
        script.onerror = error => reject(error);
        document.body.appendChild(script);
        script.src = src;
      });
      if (mapkit) {
        mapkit.init({
          authorizationCallback(done) {
            dispatch('getOrRefreshMapKitKey').then(jwt => done(jwt));
          },
          language: 'en',
        });
        commit('SET_MAPKIT', mapkit);
      }
    },
  },
};
